module.exports = __webpack_public_path__ + "img/d3f5371.jpg";